import { catchError } from 'rxjs/operators';
import { DocumentModel } from './../models/simple-types/document.model';
import { Observable } from 'rxjs';
import { InterfaceSageDTO } from './../dtos/interface-sage-dto';
import { APICONSTANTS } from 'src/app/shared/constants/api-constants';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericCrudService } from './basic/generic.crud.service';
import { HostnameService } from './basic/hostname.service';

@Injectable({
  providedIn: 'root'
})
export class InterfaceService extends GenericCrudService<InterfaceSageDTO>{
  constructor(protected http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEINTERFACE, hostnameService);
  }

  generateFile(interfaceSageDTO: InterfaceSageDTO): Observable<boolean> {
    return this.http.post<InterfaceSageDTO>(APICONSTANTS.URLAPI.value + this.route + 'GenerateSageFile', interfaceSageDTO)
        .pipe(catchError(err => this.requestCatchError(err, 'Generation de fichiers')));
}
}
